import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import moment from "moment";

const LeadView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [lead, setLead] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);

  
  const deletePublicLead = async () => {
    const result = await WhatsAppAPI.deletePublicLead(lead.id);
    if (result.success) {
      navigate(`/web_leads`);
    }
  };

  const handleBack = () => {
    navigate("/web_leads");
  }

  const editLead = (lead) => {
    navigate(`/web_leads/${lead.id}`, { state: lead });
  };


  const leadTitle = [lead.first_name, lead.last_name].filter(Boolean).join(" ").trim();

  return (
    <>
      <div className="app-view-page">
        <div className="lead-header">
          <div className="min-w-0 flex-grow-1 pe-2">
            <p className="lead-label">Lead</p>
            <h3 className="lead-title text-capitalize text-break">
              {leadTitle || "—"}
            </h3>
          </div>
          <div className="lead-actions">
            <Button className="btn-sm btn-back" onClick={handleBack}>
              Back
            </Button>
            <Button className="btn-sm btn-edit" onClick={() => editLead(lead)}>
              Edit
            </Button>
            <Button
              className="btn-sm btn-delete"
              onClick={() => setModalShow(true)}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="lead-card">
          <Row className="view-form g-0">
          <Col lg={12} sm={12} xs={12} >
            <Row className="py-2 ibs-edit-form">
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Lead Name</label>
                <span className="text-capitalize">
                {lead.first_name ? lead.first_name + " " : <>&nbsp;</>}
                {lead.last_name ? lead.last_name : <>&nbsp;</>}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Phone</label>
                <span> {(lead.country_code || '') + (lead.mobile_no || '\u00A0')}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Email</label>
                <span>{lead.email ? lead.email : <>&nbsp;</>}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Company</label>
                {
                    lead.convertedcompanyid && lead.status === 'Closed - Converted' ? (
                      <Link to={`/company/${lead.convertedcompanyid}`}>
                        <span>{lead.company ? lead.company : <>&nbsp;</>}</span>
                      </Link>
                    ) : (
                        <span>{lead.company ? lead.company : <>&nbsp;</>}</span>
                    )
                  }
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Status</label>
                <span>{lead.status ? lead.status : <>&nbsp;</>}</span>
              </Col>
           
              
              {lead.status === 'Closed - Not Converted' && (
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Lost Reason</label>
                  <span>{lead.lostreason ? lead.lostreason : <>&nbsp;</>}</span>
                </Col>
              )}
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Description</label>
                <span>{lead.description ? lead.description : <>&nbsp;</>}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Address</label>
                <span>{lead.street ? lead.street : <>&nbsp;</>}  {lead.city ? lead.city : <>&nbsp;</>} {lead.state ? lead.state : <>&nbsp;</>} &nbsp;{lead.country ? lead.country : <>&nbsp;</>}&nbsp;{lead.zipcode}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Created Date</label>
                <span>{lead.createddate ? moment(lead.createddate).format("DD MMM, yyyy") : <>&nbsp;</>}</span>
              </Col>
            </Row>
          </Col>
        </Row>
        </div>
      </div>

      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deletePublicLead={deletePublicLead}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="web_lead"
        />
      )}
    </>

  );
};
export default LeadView;